export var newListingsPageTypeFromSearchType = searchType => {
  switch (searchType) {
    case 'new-listings':
    case 'strict-new-listings':
      return 'new-listings';
    case 'new-price':
      return 'new-price';
    default:
      return null;
  }
};